import { render, staticRenderFns } from "./CouponCode.vue?vue&type=template&id=4034a0c4"
import script from "./CouponCode.vue?vue&type=script&lang=js"
export * from "./CouponCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports